import React, { useState } from 'react';
import './footer.css';
import { Link } from 'react-router-dom';
import logoimg from '../images/img1234.png';
import foterlogo from '../images/irs.png';
import instagram from '../images/insta.png';
import facebook from '../images/fb.png';
import linkedin from '../images/linkedin.png';
import x from '../images/x.png';

import foterlogoo from '../images/Visa.png';
import foterlogooo from '../images/MC.png';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from 'react-icons/fa';

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [subscriptionError, setSubscriptionError] = useState('');
  const [emaill, setEmaill] = useState('info@clasptax.com');

  const handleEmailClickk = () => {
    window.location.href = `mailto:${emaill}`;
  };

  const handleSubscribe = async () => {
    try {
      const response = await fetch('http://localhost:3002/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setIsSubscribed(true);
      } else {
        const data = await response.json();
        setSubscriptionError(data.message);
      }
    } catch (error) {
      console.error('Error subscribing:', error);
    }
  };

  return (
    <div>
      <footer className="footer-main-container">
        <div className="footer-primary">
          <div className="footer-column footer-about">
            <div className="footer-logo-container">
              <img src={logoimg} alt="Clasp Tax Logo" className="footer-logo-img" />
              <div className="footer-logo-text">
                <h5>Clasp Tax</h5>
                <p className="footer-tagline">Your Numbers. Our Expertise.</p>
              </div>
              <div className="footer-social-icons">
              <img src={foterlogo} alt="IRS Logo" className="footer-logo" />
              <img src={foterlogoo} alt="IRS Logo" className="footer-logo" />
              <img src={foterlogooo} alt="IRS Logo" className="footer-logo" />
            </div>
            </div>
          </div>

          <div className="footer-column footer-links">
            <h8 className="footer-quick-links-title">Quick Links</h8>
            <div className="footer-quick-links-wrapper">
              <ul className="footer-ul">
         
                <li><Link to="/signup">Register Now</Link></li>
                <li><Link to="/refundstatus">Refund Status</Link></li>
            


                <li><Link to="/refundpolicy">Refund Policy</Link></li>
                <li><Link to="/privacypolicy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms and Conditions</Link></li>
              </ul>
            </div>
          </div>

          <div className="footer-column footer-get-in-touch">
            <h8 className="footer-quick-links-title">Get in Touch</h8>
            <p className="footer-phone-number">Phone Number: +1 (972)-220-9783</p>
            <p className="footer-address">ClaspTax Inc: 81 Thorn Lane, Newark, DE 19711</p>
            <p className="footer-address">ClaspTax LLC: 1810 Nellora Ln, Durham, NC 27703</p>
            <p onClick={handleEmailClickk}>Email: {emaill}</p>
            <div className="footer-social">
  <a href="https://www.linkedin.com/in/clasp-tax-inc-1714b4332/" target="_blank" rel="noopener noreferrer">
    <img src={linkedin} alt="LinkedIn Logo" className="footer-social-icon" />
  </a>
  <a href="https://www.facebook.com/profile.php?id=61567059173594" target="_blank" rel="noopener noreferrer">
    <img src={facebook} alt="Facebook Logo" className="footer-social-icon" />
  </a>
  <a href="https://www.instagram.com/clasptax/?hl=en" target="_blank" rel="noopener noreferrer">
    <img src={instagram} alt="Instagram Logo" className="footer-social-icon" />
  </a>
  <a href="https://x.com/ClaspTaxInc" target="_blank" rel="noopener noreferrer">
    <img src={x} alt="X (Twitter) Logo" className="footer-social-icon" />
  </a>
</div>

           
          </div>
        </div>

        <div className="footer-copyright">
          <p>&copy; 2024 Clasp Tax | All Rights Reserved</p>
         
        </div>
      </footer>
    </div>
  );
};